import React from 'react'
import {
  createBrowserRouter,
} from 'react-router-dom'

import { Root } from './Root'
import { GroupsOverviewPage } from '../pages/groups-overview/GroupsOverviewPage'
import { GroupPage } from '../pages/group/GroupPage'
import { MemberPage } from '../pages/member/MemberPage'
import { LessonAccessControlPage } from '../pages/lesson-access-control/LessonAccessControlPage'
import { EducatorResourcesPage } from '../pages/educator-resources/EducatorResourcesPage'

// Exported separately so tests can mount the same routes on their own router.
// createBrowserRouter reads the real address bar, so a bookmark, refresh, or
// pasted /educator-resources link lands on the page it names (F20).
const routes = [
  {
    path: '/',
    element: <Root />,
    handle: 'root',
    children: [
      {
        index: true,
        element: <GroupsOverviewPage />,
      },
      {
        path: 'educator-resources',
        element: <EducatorResourcesPage />,
        handle: 'educator-resources',
      },
      // The two rails ARE the URL (D26): pack first, folder second, so a
      // button on firialabs.com can land a teacher on one section of one
      // pack. Both segments are optional - a bare /educator-resources still
      // works, and an unknown slug resolves to the first pack or folder
      // rather than erroring, because Drive folders get renamed.
      {
        path: 'educator-resources/:packSlug',
        element: <EducatorResourcesPage />,
        handle: 'educator-resources',
      },
      {
        // Splat, not a single segment: folders nest arbitrarily deep in Drive
        // (D32), so the whole slug path after the pack is the folder address.
        path: 'educator-resources/:packSlug/*',
        element: <EducatorResourcesPage />,
        handle: 'educator-resources',
      },
      {
        path: 'group/:groupId',
        element: <GroupPage />,
        handle: 'group',
      },
      {
        path: 'group/:groupId/member/:memberId',
        element: <MemberPage />,
        handle: 'member',
      },
      {
        path: 'group/:groupId/lesson-access-control',
        element: <LessonAccessControlPage />,
        handle: 'lesson-access-control',
      },
      {
        path: 'group/:groupId/member/:memberId/lesson-access-control',
        element: <LessonAccessControlPage />,
        handle: 'lesson-access-control',
      },
    ],
  },
]

const router = createBrowserRouter(routes)

export { router, routes }
